<template>
    <div class="post">
        <div class="left section">
            <el-skeleton class="featured-image" animated>
                <template #template>
                    <el-skeleton-item variant="image" style="width:100%;height:100%;"/>
                </template>
            </el-skeleton>
        </div>
        <div class="right section">
            <el-skeleton :rows="3" animated />
        </div>
    </div>
</template>
<script>
    import {
        ElSkeleton,
        ElSkeletonItem
    } from 'element-plus';
    export default {
        components: {
            ElSkeleton,
            ElSkeletonItem
        }
    }
</script>
<style lang="scss" scoped>
    .post {
        display: flex;
        margin: 3.5rem .5rem;
        // border-bottom: 1px solid gray;

        .left.section {

            width: 33%;
            min-width: 200px;

            .featured-image {
                width: 100%;
                height: 150px;
            }

        }

        .right.section {
            flex: 1;
            padding: .5em 1em;
            position: relative;

            p {
                margin: 0;
            }

            a.link {
                color: #01a7a9;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .title {
                // font-size: 1.2rem;
                font-weight: bold;
            }

            .info-divider {
                border-top: 1px solid #dedede;
            }

            .abstract {
                color: gray;
                margin-bottom: 2rem;
            }

            .footer {

                position: absolute;
                bottom: .5em;
                left: 1em;
                right: 1em;

                display: flex;
                justify-content: space-between;

                font-size: .9rem;
                color: gray;
            }
        }

        @media (max-width: 560px) {

            flex-direction: column;

            .left.section {
                width: 100%;
            }

            .right.section {
                margin-top: 1rem;
                padding: .5em .25em;

                .footer {
                    left: .25em;
                    right: .25em;
                }
            }

        }
    }
</style>